import styled from 'styled-components'

export const MenuDropdownStyled = styled.div`
    .cs-dropdown {
        cursor: pointer;
        -webkit-tap-highlight-color: transparent;
        background-color: var(--light-blue-color);
        gap: 8px;
        padding: 7px 14px 7px 10px;
        border-radius: 10px;
        .placeholder-img {
            border-radius: 50%;
            width: 18px;
            height: 18px;
            display: block;
        }

        .action-icon {
            color: var(--pure-black-color);
        }

        .dropdown-title {
            font-size: 12px;
            font-weight: 500;
            color: var(--royal-blue-color);
        }

        .dropdown-icon {
            width: 16px;
            margin-left: -4px;
            height: 16px;
            display: block;
            color: var(--royal-blue-color);
        }
    }

    .dropdown-opened {
        box-shadow: 0 0 0 1px var(--royal-blue-color);
    }
`